import { saveAs } from 'file-saver';

export function downloadFile(data: ArrayBuffer | string, type: string, fileName: string): void {
  const fileBlob = new Blob([data], { type });
  saveAs(fileBlob, fileName);
}
